<div>
  <p-confirmDialog acceptIcon="pi pi-check" rejectIcon="pi pi-times" header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <p-dialog appendTo="body" [modal]="true" [draggable]="false" [header]="'block_unverified_sender_modal_title' | i18n"
    [(visible)]="unverifiedSenderActionModalVisible" [style]="{width: '50vw'}">
    <form class="" [formGroup]="unverifiedSenderDomainForm">

      @for (action of unverifiedSenderDomainActions; track action) {
        <div class="flex items-start gap-4 mt-4">
          <p-radioButton inputId="disable" [value]="action" formControlName="unverified_domain_action"></p-radioButton>
          <div class="grow text-start">
            <div class="font-bold text-lg">{{ action + '_title' | i18n }}</div>
            <p [innerHTML]="action+'_info' | i18n"></p>
          </div>
        </div>
      }
    </form>

    <div class="footer text-end mt-6">
      <p-button (onClick)="unverifiedSenderModalClose()" [label]="'settings_link_branding_match_modal_cancel' | i18n"
        styleClass="p-button-outlined p-button-secondary me-2" [outlined]="true"
      icon="pi pi-times" iconPos="left"></p-button>
      <p-button (onClick)="unverifiedSenderModalSave()"
        [label]="'settings_link_branding_match_modal_confirm' | i18n"
      icon="pi pi-check" iconPos="left"></p-button>
    </div>
  </p-dialog>

  <p-table
    styleClass="p-datatable-striped p-datatable-gridlines p-datatable-responsive-stack"
    responsiveLayout="stack"
    [value]="verifiedDomains"
    [lazy]="true"
    (onLazyLoad)="loadVerifiedDomains($event)"
    [rows]="customDomainsLimit"
    [totalRecords]="verifiedDomainsCount"
    [class.is-table-loading]="verifiedDomainsLoading && !verifiedDomainsCount"
    [rowHover]="true"
    [paginator]="true"
    [showJumpToPageDropdown]="true"
    [showCurrentPageReport]="false"
    [rowsPerPageOptions]="[5,10,25,50,100]"
    [loading]="verifiedDomainsLoading"
    #verifiedDomainsTable
    >
    <ng-template pTemplate="caption">
      @if (hasFiltersActive || verifiedDomainsCount > 0) {
        <div>
          <div class="flex content-between items-center gap-4">
            <span class="block ms-0 text-center lg:inline"><p-toggleButton
              [formControl]="showFilters"
              [onLabel]="'filters_hide' | i18n"
              [offLabel]="'filters_show' | i18n"
              onIcon="pi pi-minus-circle"
              offIcon="pi pi-plus-circle"
              iconPos="right"
              styleClass="p-button-link advanced-search-button">
            </p-toggleButton>
          </span>
          <span class="block flex-1 sm:w-auto sm:flex justify-end text-end">
            <p-button (onClick)="openCreateDomain()" [label]="'settings_sender_add_domain'|i18n" icon="pi pi-plus" iconPos="right"></p-button>
          </span>
        </div>
        <div class="flex-grid mt-4" [class]="!showFilters.value ? 'hidden' : ''" [formGroup]="verifiedDomainForm">
          <div class="col-12 md:col-8">
            <p-iconfield class="w-full">
              <p-inputicon><i class="pi pi-search"></i></p-inputicon>
              <input class="inputfield w-full" type="text" formControlName="search"
                [placeholder]="'settings_sender_domains_search_placeholder' | i18n" pInputText>
              <p-inputicon><i class="pi pi-times cursor-pointer"
              (click)="verifiedDomainForm.get('search').patchValue(null)"></i></p-inputicon>
            </p-iconfield>
          </div>
          <div class="text-start col-12 md:col-4">
            <p-select [showClear]="true" appendTo="body"
              formControlName="filterByVerification"
              [placeholder]="'settings_sender_domains_status_placeholder' | i18n"
              [options]="verificationTypes"
            styleClass="w-full"></p-select>
          </div>
        </div>
      </div>
    }

  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td class="border-t">
        @if (hasFiltersActive) {
          <div>
            <div class="no-content p-6 text-center">
              <div>
                <p>{{'settings_sender_domains_filters_no_results' | i18n }}</p>
              </div>
            </div>
          </div>
        } @else {
          <div class="py-8 text-center">
            <p [innerHTML]="'settings_sender_domains_empty' | i18n"></p>
            <p>
              <p-button (onClick)="openCreateDomain()" [label]="'settings_sender_add_domain'|i18n" icon="pi pi-plus" iconPos="right"></p-button>
            </p>
          </div>
        }
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="header">
    @if (verifiedDomainsCount > 0) {
      <tr>
        <th pSortableColumn="sender_domain">{{ 'settings_sender_domains_name' | i18n }}
          <p-sortIcon field="sender_domain"></p-sortIcon>
        </th>
        <th class="w-[6rem] text-center">SPF</th>
        <th class="w-[6rem] text-center">DKIM</th>
        <th class="w-[6rem] text-center">DMARC</th>
        @if (!isSubaccount) {
          <th class="text-center">{{ 'settings_sender_domains_action' | i18n }}</th>
        }
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-domain>
    <tr>
      <td class="gap-2 justify-start">
        <div class="flex items-center gap-6">
          <span class="grow">
            @if (domain.spf_verified && domain.dkim_verified && domain.dmarc_verified) {
              <i
              class="text-green-500 pi pi-fw pi-verified"></i>
            } @else {
              <i class="text-red-500 pi pi-fw pi-exclamation-circle"></i>
            }
            {{ domain.domain }}
          </span>
          @if (domain.subaccount) {
            <i class="pi pi-fw pi-user cursor--help"
              [pTooltip]="('settings_sender_domains_action_subaccount' | i18n) + '<br>' + domain.subaccount"
              [escape]="false" tooltipStyleClass="dns__tooltip--subaccount-email"
            tooltipPosition="top"></i>
          }
        </div>
        <span class="p-column-title">{{ domain.subaccount }}</span>
      </td>
      <td class="text-center justify-start gap-2">
        <i [class]="domain.spf_verified ? 'pi-verified text-green-500' : 'pi-exclamation-circle text-red-500'"
        class="pi pi-fw"></i>
        <span class="p-column-title">SPF</span>
      </td>
      <td class="text-center justify-start gap-2">
        <i [class]="domain.dkim_verified ? 'pi-verified text-green-500' : 'pi-exclamation-circle text-red-500'"
        class="pi pi-fw"></i>
        <span class="p-column-title">DKIM</span>
      </td>
      <td class="text-center justify-start gap-2">
        <i [class]="domain.dmarc_verified ? 'pi-verified text-green-500' : 'pi-exclamation-circle text-red-500'"
        class="pi pi-fw"></i>
        <span class="p-column-title">DMARC</span>
      </td>
      @if (!isSubaccount) {
        <td class="nowrap w-[1rem]">
          <div class="flex items-center gap-1">
            <button pButton class="p-button-xs" (click)="openVerifyDomain(domain.id)">
              {{ 'settings_sender_domains_action_verify' | i18n }}
            </button>
            <button pButton class="p-button-xs p-button-outlined p-button-danger"
              (click)="confirmDelete(domain.id, domain.domain)">
              {{ 'settings_sender_domains_action_delete' | i18n }}
            </button>
          </div>
          <!--
          <a (click)="openVerifyDomain(domain.id)">{{'settings_sender_domains_action_verify' | i18n}}</a>
          <span *ngIf="!domain.spf_verified && !domain.dkim_verified && !domain.dmarc_verified || 1==1"> |
            <a (click)="confirmDelete(domain.id)" class="text-red-500">{{'settings_sender_domains_action_delete' | i18n}}</a>
          </span>
          -->
        </td>
      }
    </tr>
  </ng-template>
</p-table>

<div class="flex gap-2 mt-4">
  <i class="pi pi-info-circle mt-1"></i>
  <div class="text-start mt-0 grow">
    <div class="mb-2">{{ 'settings_sender_if_unverified' | i18n }}</div>
    @if (!unverifiedSenderCurrentAction) {
      <div>
        <p-message severity="info">
            <div>
              <p class="mt-0">
                <strong>{{ 'notice'|i18n }}</strong>
              </p>
              <div [innerHTML]=" 'settings_sender_domains_no_option'|i18n "></div>
              @if (!isSubaccount) {
                <div>
                  <a (click)="unverifiedSenderActionModalVisible = true" class="p-button p-button p-button-info">
                    {{ 'block_unverified_sender_change' | i18n }}
                  </a>
                </div>
              }
            </div>
</p-message>
      </div>
    } @else {
      <div>
        <h4>{{ unverifiedSenderCurrentAction + '_title' | i18n }} @if (!isSubaccount) {
          <small class="font-normal ms-2"><a
            (click)="unverifiedSenderActionModalVisible = true"
          class="p-button p-button-outlined p-button-xs p-button-info">{{ 'block_unverified_sender_change' | i18n }}</a></small>
        }
      </h4>
      <p class="mt-1">
        <span [innerHTML]="unverifiedSenderCurrentAction+'_info'| i18n"></span>
      </p>
    </div>
    @if (!isSubaccount) {
      <div [formGroup]="senderDomainNotificationForm">
        <div class="flex items-center gap-2 mt-6">
          <p-checkbox [binary]="true" (onChange)="enableSendNotification($event.checked)" inputId="sendNotification"
          formControlName="enabled"></p-checkbox>
          <label for="sendNotification">{{ 'settings_sender_notify_label' | i18n }}</label>
        </div>
        @if (!!senderDomainNotificationForm.get('enabled').value) {
          <div #notificationField class="flex flex-col gap-2 gap-2 mt-6 w-full"
            >
            <label>{{ 'settings_sender_notify_email_label' | i18n }}</label>
            <div class="p-inputgroup w-full xl:w-6/12">
              <input type="text" formControlName="notification_email" pInputText class="force-ltr"
                placeholder="{{'settings_sender_notify_email_placeholder' | i18n}}"/>
              <button type="button" (click)="saveNotificationEmail()" [loading]="saveNotificationEmailLoading" pButton
              icon="pi pi-save" class="p-button-warn"></button>
            </div>
            @if (senderDomainNotificationForm.get('notification_email').hasError('email')) {
              <small class="p-error">
                <i class="pi pi-exclamation-triangle"></i> {{ 'settings_sender_notify_email_error' | i18n }}
              </small>
            }
            <small>{{ 'settings_sender_notify_email_tip' | i18n }}</small>
          </div>
        }
      </div>
    }
  }

</div>
</div>
</div>
